export default __webpack_public_path__ + "static/media/logoSample6.45236a8d.png";